import { createAsyncThunk } from '@reduxjs/toolkit';
import { AppServerResponse } from '../../utils/interfaces/generalInterfaces';
import axios from 'axios';
import { BASE_API_URL } from '../../utils/constants';
import { logoutUser } from './authService';
import { myFirebaseAuth } from '../../firebase/config';
import {
  CreditApplicationReferenceUpdate,
  CreditApplicationReferenceCreate,
} from '@dill/dill-shared';

export const createCreditApplicationReference = createAsyncThunk(
  'creditApplicationReferences/createCreditApplicationReference',
  async (
    {
      data,
    }: {
      data: CreditApplicationReferenceCreate & { referencePos?: string };
    },
    thunkApi
  ) => {
    try {
      const response = await axios.post<AppServerResponse>(
        `${BASE_API_URL}/creditApplications/createCreditApplicationReference`,
        { ...data },
        {
          headers: {},
        }
      );

      return response.data;
    } catch (error: any) {
      console.log(error?.message);
      if (error?.response?.status === 401) {
        thunkApi.dispatch(logoutUser());
      }
      return thunkApi.rejectWithValue(error.message);
    }
  }
);

export const getCreditApplicationReferences = createAsyncThunk(
  'creditApplicationReferences/getCreditApplicationReferences',
  async ({ supplierId }: { supplierId: string }, thunkApi) => {
    try {
      const token = await myFirebaseAuth.currentUser?.getIdToken();
      if (!token) {
        return null;
      }

      const response = await axios.get<AppServerResponse>(
        `${BASE_API_URL}/suppliers/${supplierId}/creditApplications/getCreditApplicationReferences`,
        {
          headers: {
            Authorization: 'Bearer ' + token,
          },
        }
      );

      return response.data;
    } catch (error: any) {
      console.log(error?.message);
      if (error?.response?.status === 401) {
        thunkApi.dispatch(logoutUser());
      }
      return thunkApi.rejectWithValue(error.message);
    }
  }
);

export const getCreditApplicationReference = createAsyncThunk(
  'creditApplicationReferences/getCreditApplicationReference',
  async ({ templateId }: { templateId: string }, thunkApi) => {
    const token = await myFirebaseAuth.currentUser?.getIdToken();
    if (!token) {
      return null;
    }
    try {
      const response = await axios.get<AppServerResponse>(
        `${BASE_API_URL}/creditApplications/getCreditApplicationReference/${templateId}`,
        {
          headers: { Authorization: 'Bearer ' + token },
        }
      );

      return response.data;
    } catch (error: any) {
      console.log(error?.message);
      if (error?.response?.status === 401) {
        thunkApi.dispatch(logoutUser());
      }
      return thunkApi.rejectWithValue(error.message);
    }
  }
);

export const updateCreditApplicationReference = createAsyncThunk(
  'creditApplicationReferences/updateCreditApplicationReference',
  async (
    {
      supplierId,
      templateId,
      templateDetails,
    }: {
      supplierId: string;
      templateId: string;
      templateDetails: CreditApplicationReferenceUpdate;
    },
    thunkApi
  ) => {
    try {
      const token = await myFirebaseAuth.currentUser?.getIdToken();
      if (!token) {
        return null;
      }

      const response = await axios.put<AppServerResponse>(
        `${BASE_API_URL}/suppliers/${supplierId}/creditApplications/updateCreditApplicationReference/${templateId}`,
        { ...templateDetails },
        {
          headers: {
            Authorization: 'Bearer ' + token,
          },
        }
      );

      return response.data;
    } catch (error: any) {
      console.log(error);
      if (error?.response?.status === 401) {
        thunkApi.dispatch(logoutUser());
      }
      return thunkApi.rejectWithValue(error.message);
    }
  }
);

export const updateReferenceInCreditApp = createAsyncThunk(
  'creditApplicationReferences/updateReferenceInCreditApp',
  async (
    {
      data,
    }: {
      data: {
        referenceId: string;
        email: string;
        creditApplicationId: string;
        referencePos?: string;
      };
    },
    thunkApi
  ) => {
    try {
      const response = await axios.post<AppServerResponse>(
        `${BASE_API_URL}/creditApplications/updateReferenceInCreditApp`,
        { ...data },
        {
          headers: {},
        }
      );

      return response.data;
    } catch (error: any) {
      console.log(error?.message);
      if (error?.response?.status === 401) {
        thunkApi.dispatch(logoutUser());
      }
      return thunkApi.rejectWithValue(error.message);
    }
  }
);
